import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import Select from "react-select";
import AuthContext from "../../Context/AuthContext";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions";
import ajaxDepartments from "../../util/remote/ajaxDepartments";
const UpdateRequisition = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state: requisition } = useLocation(); // requisition passed from ViewRequisitions
  const [departments, setDepartments] = useState([]);
  const [deptID, setDeptID] = useState(null);
  const [naration, setNaration] = useState("");
  const [items, setItems] = useState([]);
  // Fetch department list
  const fetchDepartments = async () => {
    const server_response = await ajaxDepartments.fetchDepartmentsList({});
    if (server_response.status === "OK") {
      const options = server_response.details.map((d) => ({
        value: d.id,
        label: d.department,
      }));
      setDepartments(options);
      if (requisition?.deptID) {
        const match = options.find((opt) => opt.value === requisition.deptID);
        if (match) setDeptID(match);
      }
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchDepartments();
  }, []);
  // Prefill requisition data
  useEffect(() => {
    if (requisition) {
      setNaration(requisition.naration || "");
      setItems(
        (requisition.items || []).map((item) => ({
          id: item.id,
          item_name: item.item_name,
          quantity: item.quantity,
          unit: item.unit || "",
          est_unit_cost: item.est_unit_cost,
          actual_cost: item.actual_cost || "",
        }))
      );
    }
  }, [requisition]);
  // Handlers for items
  const handleAddItem = () => {
    setItems([
      ...items,
      {
        item_name: "",
        quantity: "",
        unit: "",
        est_unit_cost: "",
        actual_cost: "",
      },
    ]);
  };
  const handleRemoveItem = (index) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };
  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
  };
  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!deptID) {
      toast.error("Please select a department");
      return;
    }
    if (items.length === 0) {
      toast.error("Please add at least one item");
      return;
    }
    // Calculate est_total
    const est_total = items.reduce((sum, item) => {
      const qty = parseFloat(item.quantity) || 0;
      const cost = parseFloat(item.est_unit_cost) || 0;
      return sum + qty * cost;
    }, 0);
    const data = {
      reqID: requisition.id,
      deptID: deptID.value,
      naration,
      est_total,
      date_created:
        requisition.date_created || new Date().toISOString().split("T")[0],
      req_items_array: items.map((item) => ({
        id: item.id || 0,
        item_name: item.item_name,
        quantity: item.quantity,
        unit: item.unit,
        est_unit_cost: item.est_unit_cost,
        actual_cost: item.actual_cost,
      })),
    };
    const response = await ajaxRequisitions.updateRequisition(data);
    if (response.status === "OK") {
      toast.success("Requisition updated successfully");
      setTimeout(() => navigate("/requisitions/View"), 1500);
    } else {
      toast.error(response.message);
    }
  };
  return (
    <AppContainer title="Update Requisition">
      <div className="container-fluid">
        <Toaster />
        <div className="card shadow-sm border-0">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Department */}
              <div className="mb-3">
                <label className="form-label">Department</label>
                <Select
                  options={departments}
                  value={deptID}
                  onChange={setDeptID}
                  placeholder="Select Department"
                />
              </div>
              {/* Narration */}
              <div className="mb-3">
                <label className="form-label">Narration</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={naration}
                  onChange={(e) => setNaration(e.target.value)}
                />
              </div>
              {/* Items */}
              <div className="mb-3">
                <label className="form-label fw-bold">Items</label>
                {items.map((item, index) => (
                  <div
                    key={index}
                    className="row g-2 align-items-center mb-2 border-bottom pb-2"
                  >
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Item Name"
                        value={item.item_name}
                        onChange={(e) =>
                          handleItemChange(index, "item_name", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Qty"
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, "quantity", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Unit"
                        value={item.unit}
                        onChange={(e) =>
                          handleItemChange(index, "unit", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Est. Unit Cost"
                        value={item.est_unit_cost}
                        onChange={(e) =>
                          handleItemChange(
                            index,
                            "est_unit_cost",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Actual Unit Cost"
                        value={item.actual_cost}
                        onChange={(e) =>
                          handleItemChange(index, "actual_cost", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-2 text-end">
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => handleRemoveItem(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-success mt-2"
                  onClick={handleAddItem}
                >
                  <i className="fa fa-plus"></i> Add Item
                </button>
              </div>
              {/* Submit */}
              <div className="mt-4">
                <button type="submit" className="btn btn-primary">
                  <i className="fa fa-save me-2"></i> Update Requisition
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => navigate("/requisition/view")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default UpdateRequisition;
